import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  data: [],
  error: null,
  loading: false,
  fundCode: null,
  exportStatus: { loading: false, error: null },
}

const fundCodeSlice = createSlice({
  name: "fundCode",
  initialState,
  reducers: {
    setData(state, action) {
      state.data = action.payload
    },
    setError(state, action) {
      state.error = action.payload
    },
    setLoading(state, action) {
      state.loading = action.payload
    },
    setFundCode(state, action) {
      state.fundCode = action.payload
    },
    setExportStatus(state, action) {
      state.exportStatus = {
        loading: action.payload.loading,
        error: action.payload.error,
      }
    },
    resetState(state) {
      state.data = []
      state.error = null
      state.loading = false
      state.fundCode = null
      state.exportStatus = { loading: false, error: null }
    },
  },
})

export const fundCodeAction = fundCodeSlice.actions

export default fundCodeSlice
